import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { debounceTime, distinctUntilChanged, switchMap, tap, startWith, Observable } from 'rxjs';
import { MatOptionModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgIf, AsyncPipe } from '@angular/common';

import { DatacenterFilterApiService } from '../../../services/datacenter-filter-api.service';
import { LoadingSpinnerComponent } from '../../../components/utils/loading-spinner.component';
import { SuggestiveListFilter } from '../../../models/datacenter-filters';

interface ItemValue {
	code?: string | undefined;
	translation?: string | undefined;
}

@Component({
	selector: 'copo-suggestive-item-filter',
	templateUrl: './suggestive-item-filter.component.html',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		NgIf,
		MatFormFieldModule,
		MatInputModule,
		MatAutocompleteModule,
		FormsModule,
		ReactiveFormsModule,
		MatIconModule,
		MatOptionModule,
		LoadingSpinnerComponent,
		AsyncPipe
	],
})
export class SuggestiveItemFilterComponent implements OnInit {
	@Input() placeholder?: string;
	@Input() filterValue?: ItemValue;
	@Input() filter?: SuggestiveListFilter;

	suggestiveCtrl = new FormControl('', { nonNullable: true });

	filteredItems?: Observable<ItemValue[]>;
	isLoading = false;

	constructor(
		private readonly datacenterFilterApiService: DatacenterFilterApiService
	) {}

	ngOnInit() {
		if (this.filterValue?.translation) {
			this.suggestiveCtrl.setValue(this.filterValue.translation);
		}
		this.filteredItems = this.suggestiveCtrl.valueChanges
			.pipe(
				startWith(this.suggestiveCtrl.value),
				debounceTime(300),
				distinctUntilChanged(),
				tap((searchText: string) => {
					this.isLoading = true;
					if (this.filterValue && searchText !== this.filterValue.translation) {
						this.filterValue.translation = searchText;
						this.filterValue.code = undefined;
					}
				}),
				switchMap((query: string) => this.datacenterFilterApiService.getItemBySearchText(this.filter, query)),
				tap(() => {
					this.isLoading = false;
				})
			);
	}

	propositionChanged(proposition: ItemValue) {
		if (!this.filterValue) {
			return;
		}
		Object.assign(this.filterValue, proposition);
	}

	getDisplayTranslation(translation?: string) {
		return translation ?? '';
	}
}
